export default "__VITE_ASSET__74940f6b__"